import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import { RootState } from "src/store";

type Context = [boolean, React.Dispatch<React.SetStateAction<boolean>>];

export default function ProtectedRoutes() {
  const [collapsed, setCollapsed] = useOutletContext<Context>() || [false];
  const user = useSelector((state: RootState) => state.auth);

  const tokenExists = Boolean(user.accessToken);

  if (!tokenExists) {
    return <Navigate to="/program" />;
  }

  return <Outlet context={[collapsed, setCollapsed]} />;
}
